"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BuildSignRequestBase = /** @class */ (function () {
    function BuildSignRequestBase(type, walletId, secretType) {
        this.type = type;
        this.walletId = walletId;
        this.secretType = secretType;
    }
    return BuildSignRequestBase;
}());
exports.BuildSignRequestBase = BuildSignRequestBase;
//# sourceMappingURL=BuildSignRequestBase.js.map